import { render, staticRenderFns } from "./Habitos.vue?vue&type=template&id=c96cc6b2&scoped=true&"
import script from "./Habitos.vue?vue&type=script&lang=js&"
export * from "./Habitos.vue?vue&type=script&lang=js&"
import style0 from "./Habitos.vue?vue&type=style&index=0&id=c96cc6b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96cc6b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VChip,VCol,VContainer,VRow,VSelect})
